/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTION_PAYMENT_TYPES_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.paymentTypes,
                (memo, paymentType) => {
                    const { connection_id } = paymentType;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[connection_id] = paymentType;
                    return memo;
                },
                state,
            );
        }
    },
);